<template>
    <div class="switchs-tab" :class="{ 'is-light': theme === 'light' }">
        <div class="tabs-inner">
            <button class="switch-btn csp" :class="{ active: active === 'project' }" @click="toProjectHome">项目主页</button>
            <button
                v-if="showTrainingSpace"
                class="switch-btn csp"
                :class="{ active: active === 'space' }"
                @click="toSpace"
            >研修空间</button>
            <button
                v-if="showPaired"
                class="switch-btn csp"
                :class="{ active: active === 'paired' }"
                @click="toPaired"
            >结对空间</button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

const NEW_HOME_TYPES = [4, 5, 6, 9]
const TEACHER_SPECIAL_IDS = [735, 759, 762, 765]
const IGNORE_PROJECT_IDS = [735, 759, 762, 765, 772, 775, 778, 781, 784, 787, 791]
// 研伴/结对/三交/两级工作室：可看研修空间的角色序号（管理员356/1762、管理者、专家、助教）
const TRAINING_SPACE_ROLE_IDS = [356, 1762, 124, 123, 101]

export default {
    name: 'BannerSwitchTab',
    props: {
        // project | space | paired
        active: {
            type: String,
            default: 'project'
        },
        // dark：深蓝横幅白字；light：浅色横幅蓝字
        theme: {
            type: String,
            default: 'dark'
        }
    },
    data() {
        return {
            showPaired: false
        }
    },
    computed: {
        ...mapState({
            currentProject: state => state.user.currentProject,
            role: state => state.user.role,
            roleId: state => state.user.roleId
        }),
        // 研伴/结对/三交/两级工作室：仅指定角色序号显示研修空间
        showTrainingSpace() {
            const modelType = Number(this.currentProject && this.currentProject.modelType)
            if (NEW_HOME_TYPES.includes(modelType)) {
                return TRAINING_SPACE_ROLE_IDS.includes(Number(this.roleId))
            }
            return true
        }
    },
    watch: {
        'currentProject.id'() {
            this.loadShowPaired()
        }
    },
    mounted() {
        this.loadShowPaired()
    },
    methods: {
        async loadShowPaired() {
            if (this.active === 'paired') {
                this.showPaired = true
                return
            }
            const projectId = this.currentProject && this.currentProject.id
            if (!projectId) {
                this.showPaired = false
                return
            }
            try {
                const res = await this.$Api.Paired.getListByProject({
                    page: 1,
                    limit: 5,
                    projectId
                })
                const records = (res && res.data && res.data.records) || []
                this.showPaired = records.length > 0
            } catch (e) {
                this.showPaired = false
            }
        },
        async resolveModelType(projectId) {
            let modelType = Number(this.currentProject && this.currentProject.modelType)
            if (Number.isFinite(modelType) && modelType !== 0) return modelType
            try {
                const res = await this.$Api.Paired.getProjectDetailTime({ projectId })
                const detail = (res && res.data) || {}
                modelType = Number(detail.modelType)
                if (Number.isFinite(modelType) && modelType !== 0) {
                    this.$store.commit('getCurrentProject', {
                        ...(this.currentProject || {}),
                        ...detail,
                        id: detail.id || projectId
                    })
                }
            } catch (e) {
                /* ignore */
            }
            return modelType
        },
        async toProjectHome() {
            if (this.active === 'project') return
            const projectId = this.currentProject && this.currentProject.id
            if (!projectId) return
            const modelType = await this.resolveModelType(projectId)
            if (NEW_HOME_TYPES.includes(modelType)) {
                this.$router.push(`/projectHome/${projectId}`)
                return
            }
            let hasMain = false
            try {
                const resData = await this.$Api.Home.getNewsListByProjectId({
                    projectId,
                    page: 1,
                    limit: 4
                })
                const list = (resData && resData.data && resData.data.list) || []
                hasMain = Array.isArray(list) && list.length > 0
            } catch (e) {
                hasMain = false
            }
            this.$store.commit('getHasMain', hasMain)
            if (!hasMain) {
                this.$message({
                    duration: 1000,
                    message: '该项目暂无项目主页',
                    type: 'error'
                })
                return
            }
            this.$router.push(`/main/${projectId}/project`)
        },
        toSpace() {
            const projectId = Number(this.currentProject && this.currentProject.id)
            const managerPath = IGNORE_PROJECT_IDS.includes(projectId) ? '/home/totalWork' : '/home/totalCourse'
            const pathMap = {
                parent: '/home/schedule',
                normal: '/home/schedule',
                teacher: TEACHER_SPECIAL_IDS.includes(projectId) ? '/home/mytask' : '/home/schedule',
                student: '/home/schedule',
                expert: '/home/schedule',
                assistant: '/home/schedule',
                school: '/home/leader_home',
                leader: '/home/leader_home',
                manager: managerPath,
                'bc-manager': managerPath
            }
            this.$router.push(pathMap[this.role] || '/home/schedule')
        },
        toPaired() {
            if (this.active === 'paired') return
            this.$router.push('/paired')
        }
    }
}
</script>

<style lang="less" scoped>
.switchs-tab {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(255, 255, 255, 0.2);

    .tabs-inner {
        width: 990px;
        margin: 0 auto;
        padding: 20px 0;
    }

    .switch-btn {
        color: #fff;
        line-height: 31px;
        padding: 0 30px;
        border: 1px solid transparent;
        margin-right: 34px;
        font-size: 13px;
        background: none;
        cursor: pointer;

        &.active {
            border: 1px solid #fff;
            border-radius: 25px;
        }
    }

    &.is-light {
        background: rgba(255, 255, 255, 0.45);

        .tabs-inner {
            width: 1200px;
            max-width: 100%;
        }

        .switch-btn {
            color: #2E58F8;

            &.active {
                border-color: #2E58F8;
            }
        }
    }
}

@media screen and (min-width: 1250px) {
    .switchs-tab {
        .tabs-inner {
            width: 1200px;
            padding: 24px 0;
        }

        .switch-btn {
            line-height: 38px;
            padding: 0 36px;
            margin-right: 44px;
            font-size: 16px;
        }
    }
}
</style>
